export interface VariableState {
    isVariableListModified: boolean;
  }
   
export const defaultVariableState = function() {
    return {isVariableListModified: false};
  };